export default __webpack_public_path__ + "static/media/add_purple.6cf2a91e.svg";